var React = require('react');
var ReactNative = require('react-native');

var LinkingManager = require('./wrappers/LinkingManager');
var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager');

const Icon = require('./wrappers/ReUpIcon');
var WebView = require('./wrappers/WebView-wrapper');
var Keyboard = require('./wrappers/Keyboard-wrapper');

var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpField = require('./ReUpField.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var ReUpCountdown = require('./ReUpCountdown');
var { BlurView, VibrancyView } = require('./wrappers/react-native-blur-wrapper');
var MapView = require('./wrappers/react-native-maps-wrapper');
var ReUpButton = require('./ReUpButton');
var moment = require('moment');

var ParallaxScrollView = require('./wrappers/react-native-parallax-scroll-view-wrapper');

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton,
  MKSpinner,
  MKProgress
} = MK;

var {
  View,
  Animated,
  ScrollView,
  StyleSheet,
  Platform,
} = ReactNative;

var dummyOrderObject = {
  CurrentInQueue : 1,
  OrderID : 123,
  OrderStatus : 0,
  StatusMessage : "Being prepared...",
  StatusText: "Being made...",
  TotalInQueue: 12,
  WaitingTime: 25,
}

var _cachedDistances = {};
function calculateDistance(lat1, lon1, lat2, lon2)
{
  if( typeof lat1 === 'undefined' || typeof lon1 === 'undefined' || typeof lat2 === 'undefined' || typeof lon2 === 'undefined' ||
      lat1 == null || lon1 == null || lat2 == null || lon2 == null ||
      parseFloat(lat1) == 0 || parseFloat(lon1) == 0 || parseFloat(lat2) == 0 || parseFloat(lon2) == 0 )
  {
    return Number.MAX_VALUE;
  }
  var cachedKey = lat1 + "," + lon1 + "-" + lat2 + "," + lon2;
  if( typeof _cachedDistances[cachedKey] !== 'undefined' ) return (_cachedDistances[cachedKey] * 1000).toFixed(2);

  var radlat1 = Math.PI * lat1/180;
  var radlat2 = Math.PI * lat2/180;
  var theta = lon1-lon2;
  var radtheta = Math.PI * theta/180;
  var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist);
  dist = dist * 180/Math.PI;
  dist = dist * 60 * 1.1515;

  _cachedDistances[cachedKey] = dist

  return (_cachedDistances[cachedKey] * 1000).toFixed(2);
}

function getLocationInfo(location)
{
  var latitude = typeof location.latitude !== 'undefined' ? location.latitude : ((typeof location.Address !== 'undefined' && location.Address.Latitude !== 'undefined') ? location.Address.Latitude : 0);
  var longitude = typeof location.longitude !== 'undefined' ? location.longitude : ((typeof location.Address !== 'undefined' && location.Address.Longitude !== 'undefined') ? location.Address.Longitude : 0);
  var name = typeof location.name !== 'undefined' ? location.name : location.Name;
  var address = typeof location.address !== 'undefined' ? location.address.trim() : (location.Address.Line1 + " " + location.Address.Line2).trim();
  var storeID = typeof location.store_id !== 'undefined' ? location.store_id : location.LocationID;
  var url = typeof location.url !== 'undefined' ? location.url : location.GrabbURL;

  return {latitude, longitude, name, address, storeID, url}
}

function getParameterByName(url, name)
{
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(url);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

var ACTIVE_ORDER_EXPIRY_SECONDS = 60*5;
var ACTIVE_ORDER_DISMISS_KEY = "ACTIVE_ORDER_DISMISS_KEY";
var LAST_ACTIVE_ORDER_STORE_ID = "LAST_ACTIVE_ORDER_STORE_ID";

var OrderAhead = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
    }
  },

  getInitialState : function()
  {
    var hasCurrentPosition = this.props.appManager.hasCurrentPosition();

    return {
      locations:[],
      filteredLocations:[],
      layout : this.props.initialLayout,
      shouldShowX:false,
      searchQuery:"",
      searchKey:0,
      selectedLocation: null,
      modalOpacity: new Animated.Value(0),
      isWebViewLoading: false,
      webViewLoadingOpacity:new Animated.Value(1),
      progressOpacity:new Animated.Value(0),
      mapView:<View />,
      currentPosition:this.props.appManager.getCurrentPosition(),
      instructionHeight: 0,
      parallaxHeaderHeight:this.props.initialLayout.height/2,
      activeOrders:null,
      showOneLocation:hasCurrentPosition,
      orderIsReady:false
    }
  },

  componentDidMount : function()
  {
    var thisThing = this;
    this.props.appManager.updateCurrentPosition(()=>
    {
      // if location is different, then do an update
      setTimeout(()=>
      {
        thisThing.forceUpdate()
      },1000)
      if( typeof thisThing._ref_parallax !== 'undefined' && typeof thisThing._ref_parallax.refs.ScrollView !== 'undefined' && typeof thisThing._ref_parallax.refs.ScrollView.doOnlineUpdate !== 'undefined' ) thisThing._ref_parallax.refs.ScrollView.doOnlineUpdate()
      else if( thisThing._ref_ptr ) thisThing._ref_ptr.doOnlineUpdate()
    });

    setTimeout(function()
    {
      Animated.timing(
       thisThing.state.progressOpacity,
       {toValue: 1,
       duration:0},
      ).start(function()
      {

      });
    }, 0)

    setTimeout(()=>
    {
      thisThing.updateActiveOrders(()=>{})
    }, 200)

  },

  componentWillUnmount : function()
  {
    LinkingManager.removeDismissListener()
  },

  _markers: null,
  didUpdate : function(data)
  {
    if( this._disableUpdate ) return;
    //
    // TODO: this is rendering 7 god damn times, fix that shit...
    //
    if( typeof data.OrderingLocations !== 'undefined' && data.OrderingLocations != null && (this.state.locations.length <= 0 || data.OrderingLocations.length > 0) )
    {
      var locations = data.OrderingLocations;
      var currentPosition = this.props.appManager.getCurrentPosition();
      var locManager = this.props.appManager.getLocalizationManager();
      var markerTitle = locManager.localizedStringForKey("MARKER_YOUR_LOCATION_TITLE");
      var markerBody = locManager.localizedStringForKey("MARKER_YOUR_LOCATION_BODY");
      var refinedLocations = [];
      var storeIDs = [];
      for( var i = 0; i < locations.length; i++ )
      {
        var loc = locations[i];
        var {latitude, longitude, storeID} = getLocationInfo(loc);
        if( storeIDs.indexOf(storeID) >= 0 ) continue;

        // if we came to this location while logged out, lets automatically go back there
        if( this.props.appManager._loggedOutOrderingStoreIDSelected == storeID ) this.didSelectLocation(loc);
        
        storeIDs.push(storeID);
        loc.distance = calculateDistance(latitude, longitude, currentPosition.latitude, currentPosition.longitude);
        if( typeof loc.ActiveOrders !== 'undefined' ) loc.active_orders = loc.ActiveOrders;
        refinedLocations.push(loc);
      }
      locations = refinedLocations;

      var thisThing = this;
      this.props.appManager.getVariable(LAST_ACTIVE_ORDER_STORE_ID, (last_active_order_store_id)=>
      {
        locations = locations.sort(function(a,b)
        {
          var locInfoA = getLocationInfo(a);
          var locInfoB = getLocationInfo(b);
          if( last_active_order_store_id != null )
          {
            if( locInfoA.storeID == last_active_order_store_id ) return -1;
            if( locInfoB.storeID == last_active_order_store_id ) return 1;            
          }
          if( a.distance == b.distance ) return locInfoA.name.localeCompare(locInfoB.name);

          return a.distance - b.distance;
        });

        var hasStartedPoll = false;
        var filteredLocations = thisThing.filterItems(locations, thisThing._searchQuery);
        for( var i = 0; i < locations.length; i++ )
        {
          if( typeof locations[i].active_orders !== 'undefined' && locations[i].active_orders != null && locations[i].active_orders.length > 0 && !hasStartedPoll )
          {
            this._activeGrabbLocationID = locations[i].LocationID;
            this._activeGrabbToken = locations[i].Token;
            var locInfo = getLocationInfo(locations[i]);
            if( typeof locInfo.storeID !== 'undefined' ) thisThing.props.appManager.setVariable(LAST_ACTIVE_ORDER_STORE_ID, locInfo.storeID, ()=>{});

            hasStartedPoll = true;
            thisThing.filterActiveOrders(locations[i].active_orders, function(filteredActiveOrders)
            {
              thisThing.setState({activeOrders:filteredActiveOrders, locations, filteredLocations})
              thisThing.queueToPollActiveOrders();
            });
          }
        }
        thisThing.state.locations = locations;
        thisThing.setState({locations:locations, filteredLocations:filteredLocations})

        var allMarkers = []
        var region = null;
        for( var i = 0; i < locations.length; i++ )
        {
          var {latitude, longitude, name, address} = getLocationInfo(locations[i]);
          if( region == null )
          {
            region = {
              latitude:parseFloat(latitude),
              longitude:parseFloat(longitude),
              latitudeDelta:0.01,
              longitudeDelta:0.01
            };
          }
          allMarkers.push({
              latlng : {
                latitude:parseFloat(latitude),
                longitude:parseFloat(longitude)
              },
              title:name,
              description:address
            })
          // TODO: rethink this
          if( i >= 20 ) break;
        }
        if( thisThing._markers != JSON.stringify(allMarkers) )
        {
          thisThing.setState({mapView:
              <MapView key="mapview"
                region={region}
                onRegionChange={thisThing.onRegionChange}
                style={{width:thisThing.state.layout.width, flex:1}}
              >
                {allMarkers.map(marker => (
                  <MapView.Marker
                    coordinate={marker.latlng}
                    title={marker.title}
                    description={marker.description}
                  />
                ))}
                <MapView.Marker
                  coordinate={currentPosition}
                  title={markerTitle}
                  description={markerBody}
                  pinColor='blue'
                />
              </MapView>})
          thisThing._markers = JSON.stringify(allMarkers)
        }
      })
    }
  },

  _queuedToPollActiveOrder : false,
  POLL_ACTIVE_ORDER_DELAY : 5000,
  pollActiveOrderTimeout : null,
  queueToPollActiveOrders : function(activeOrders)
  {
    var thisThing = this;
    if( typeof activeOrders !== 'undefined' ) this.setState({activeOrders})
    if( thisThing.pollActiveOrderTimeout != null ) clearTimeout(thisThing.pollActiveOrderTimeout);

    this.pollActiveOrderTimeout = setTimeout(function()
    {
      thisThing.pollActiveOrderTimeout = null;
      thisThing.updateActiveOrders(function(shouldUpdateAgain)
      {
        if( shouldUpdateAgain ) thisThing.queueToPollActiveOrders();
      });
    }, this.POLL_ACTIVE_ORDER_DELAY);
  },

  filterActiveOrders: function(activeOrders, completion)
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var date = (new Date()).getTime();

    var shouldUpdate = (typeof activeOrders !== 'undefined' && date != null && activeOrders.length > 0) || (typeof thisThing.state.activeOrders === 'undefined' || thisThing.state.activeOrders == null);
    if( shouldUpdate && (thisThing.state.activeOrders != null && thisThing.state.activeOrders.length > 0) && activeOrders.length > 0 )
    {
      var oldOrder = thisThing.state.activeOrders[0];
      var newOrder = activeOrders[0];
      shouldUpdate = shouldUpdate &&
        (oldOrder.store_id != newOrder.store_id ||
          oldOrder.invoice_id != newOrder.invoice_id ||
          oldOrder.store_invoice_id != newOrder.store_invoice_id ||
          oldOrder.status != newOrder.status //||
          // oldOrder.ready_time_seconds != newOrder.ready_time_seconds
        )
      var hasCountdown = typeof thisThing._countdown !== 'undefined' && thisThing._countdown != null;
    }
    shouldUpdate = shouldUpdate || (activeOrders.length <= 0);

    //
    // choose wether to use ready_time_seconds or not
    //
    if( activeOrders.length > 0 && typeof activeOrders[0].ready_time_seconds !== 'undefined' )
    {
      var filteredActiveOrders = [];
      var nowSeconds = (new Date()).getTime()/1000;
      appManager.getVariable(ACTIVE_ORDER_DISMISS_KEY, function(shouldIgnoreBelowReadyThisReadyTimeSeconds)
      {
        if( shouldIgnoreBelowReadyThisReadyTimeSeconds == null ) shouldIgnoreBelowReadyThisReadyTimeSeconds = 0;
        shouldIgnoreBelowReadyThisReadyTimeSeconds = parseInt(shouldIgnoreBelowReadyThisReadyTimeSeconds);
        for( var i = 0; activeOrders != null && i < activeOrders.length; i++ )
        {
          var readyTimeSeconds = parseInt(activeOrders[i].ready_time_seconds);
          var secondsSinceReady = nowSeconds - readyTimeSeconds;
          if( secondsSinceReady < ACTIVE_ORDER_EXPIRY_SECONDS &&
              readyTimeSeconds > shouldIgnoreBelowReadyThisReadyTimeSeconds)
          {
            filteredActiveOrders.push(activeOrders[i]);
          }
        }

        if( shouldUpdate && activeOrders.length > 0 ) thisThing.setState({activeOrders:filteredActiveOrders, orderIsReady:false});
        if( filteredActiveOrders.length > 0 && hasCountdown && typeof filteredActiveOrders[0].ready_time_seconds !== 'undefined' )
        {
          thisThing._countdown.startCountdown(moment(filteredActiveOrders[0].ready_time_seconds*1000).toDate());
        }

        if( activeOrders.length <= 0 )
        {
          if( thisThing._ref_parallax && typeof thisThing._ref_parallax.refs.ScrollView !== 'undefined' && typeof thisThing._ref_parallax.refs.ScrollView.doOnlineUpdate !== 'undefined' ) thisThing._ref_parallax.refs.ScrollView.doOnlineUpdate();
          else if( thisThing._ref_ptr ) thisThing._ref_ptr.doOnlineUpdate();
        }
        completion( filteredActiveOrders );
      });
    }
    else
    {
      thisThing.setState({activeOrders, orderIsReady:false});
      completion( activeOrders );
    }
  },

  _activeGrabbLocationID : "", // only important for grabb
  _activeGrabbToken: "",
  updateActiveOrders: function(completion)
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var date = (new Date()).getTime();
    var merchantID = null;
    var currentDateTime = null;
    var orderingType = null;
    if( typeof appManager.getFeatureForName("Auphan") !== 'undefined' )
    {
      orderingType = "AUPHAN";
      merchantID = appManager.getFeatureForName("Auphan").data.franchise_id;
      currentDateTime =  appManager.getLocalizationManager().dateTimeAuphan(date);
    }
    else if( typeof appManager.getFeatureForName("Grabb") !== 'undefined' )
    {
      orderingType = "GRABB";
      merchantID = appManager.getFeatureForName("Grabb").data.merchantID;
      currentDateTime =  appManager.getLocalizationManager().dateTimeGrabb(date);
    }
    var locations = this.state.locations;
    for( var i = 0; i < locations.length; i++ )
    {
      if( typeof locations[i].ActiveOrders === 'undefined' ) locations[i].active_orders = locations[i].ActiveOrders;
      if( typeof locations[i].active_orders !== 'undefined' && locations[i].active_orders != null && locations[i].active_orders.length > 0  )
      {

        this._activeGrabbLocationID = locations[i].LocationID;
        this._activeGrabbToken = locations[i].Token;
      }
    }
    NetworkManager.getActiveOrders(appManager, orderingType, merchantID, this._activeGrabbLocationID, this._activeGrabbToken, currentDateTime, "", "", (activeOrders)=>
    {
      var refinedActiveOrders = [];
      for( var i = 0; i < activeOrders.length; i++ )
      {
        var refinedActiveOrder = activeOrders[i];
        // Auphan
        if( typeof activeOrders[i].store_id !== 'undefined' ) refinedActiveOrder.store_id = activeOrders[i].store_id;
        if( typeof activeOrders[i].order_id !== 'undefined' ) refinedActiveOrder.order_id = activeOrders[i].order_id;
        if( typeof activeOrders[i].ready_time_seconds !== 'undefined' ) refinedActiveOrder.ready_time_seconds = activeOrders[i].ready_time_seconds;

        // Grabb
        if( typeof activeOrders[i].LocationID !== 'undefined' ) refinedActiveOrder.store_id = activeOrders[i].LocationID;
        if( typeof activeOrders[i].OrderStatus !== 'undefined' ) refinedActiveOrder.status = activeOrders[i].OrderStatus;
        if( typeof activeOrders[i].OrderId !== 'undefined' ) refinedActiveOrder.order_id = activeOrders[i].OrderId;

        refinedActiveOrders.push(refinedActiveOrder);
      }

      thisThing.filterActiveOrders(refinedActiveOrders, (filteredActiveOrders)=>
      {
        completion( typeof filteredActiveOrders !== 'undefined' && filteredActiveOrders != null && filteredActiveOrders.length > 0 );
      });
    }, ()=>
    {
      completion(true);
    }, ()=>
    {
      completion(true);
    })
  },

  _searchQuery: "",
  searchChanged: function(newText)
  {
    var thisThing = this;
    var shouldShowX = newText.length > 0;
    if( shouldShowX != this.state.shouldShowX )
    {
      this.setState({shouldShowX:shouldShowX});
    }
    if( newText != this._searchQuery )
    {
      var filteredLocations = [];
      if( newText.length > this._searchQuery.length )
      {
        // only removing from current
        filteredLocations = this.filterItems(this.state.filteredLocations, newText);
      }
      else
      {
        filteredLocations = this.filterItems(this.state.locations, newText);
      }
      if( filteredLocations.length != this.state.filteredLocations.length )
      {
        this.setState({filteredLocations:filteredLocations})
      }
    }
    this._searchQuery = newText;
  },

  filterItems: function(items, query)
  {
    var output = [];
    var terms = query.toLowerCase().split(" ");
    for( var i = 0; i < items.length; i++ )
    {
      var {address, name} = getLocationInfo(items[i]);
      var item = (address + " " + name).toLowerCase();
      var shouldAdd = true;
      for( var j = 0; j < terms.length; j++ )
      {
        if( terms[j].length <= 0 ) continue;
        if( item.indexOf(terms[j]) <= -1 )
        {
          shouldAdd = false;
          break;
        }
      }
      if( shouldAdd ) output.push(items[i]);
    }

    return output;
  },

  didSelectLocation: function(selectedLocation)
  {
    if( selectedLocation["RequiresLogin"] )
    {
      this.doLogin();
      return;
    }

    var appManager = this.props.appManager;
    var thisThing = this;
    var navLayout = this.props.appActions.navLayout;
    var titleFontSize = 24;
    var {name, address, url, storeID} = getLocationInfo(selectedLocation);
    var title = name;
    if( title.length > 12 ) titleFontSize = 14
    
    // hack to allow the logged out ordering location to be automatically navigated to after logging in
    if( !appManager.isLoggedIn() ) appManager._loggedOutOrderingStoreIDSelected = storeID;
    else appManager._loggedOutOrderingStoreIDSelected = null

    const patchPostMessageFunction = function() {
      var originalPostMessage = window.postMessage;

      var patchedPostMessage = function(message, targetOrigin, transfer) { 
        originalPostMessage(message, targetOrigin, transfer);
      };

      patchedPostMessage.toString = function() { 
        return String(Object.hasOwnProperty).replace('hasOwnProperty', 'postMessage');
      };

      window.postMessage = patchedPostMessage;
    };

    const patchPostMessageJsCode = '(' + String(patchPostMessageFunction) + ')();';

    var injectedJavaScript = Platform.OS == 'ios' ?
        (patchPostMessageJsCode + "; document.addEventListener(\"touchmove\", ()=>{}, false); window.setInterval(()=>{window.webkit.messageHandlers.reactNative.postMessage({data: {url:window.location.href}});},200);")
      :
        (patchPostMessageJsCode + "; document.addEventListener(\"touchmove\", ()=>{}, false); window.setInterval(()=>{window.postMessage(JSON.stringify({url:window.location.href}));},200);");

    // putting this here to get rid of reborn
    injectedJavaScript = (patchPostMessageJsCode + "; document.addEventListener(\"touchmove\", ()=>{}, false); window.setInterval(()=>{window.postMessage(JSON.stringify({url:window.location.href}));},200);");

    this._locationURL = "";

    var alert = <View style={{flexDirection:'column', height:navLayout.height }} >
      <View style={{flexDirection:'column', flex:1, width:this.state.width, height:navLayout.height}}>
        <View style={{backgroundColor:appManager.getColorForKey("HeaderColor"), paddingTop:Globals.STATUS_BAR_HEIGHT, flexDirection:'row', height:Globals.ACTION_BAR_HEIGHT, width:this.state.layout.width, alignItems:'center'}}>
          <View style={{width:50, backgroundColor:'transparent', height:Globals.ACTION_BAR_HEIGHT, alignItems:'center', justifyContent:'center'}}>
            <ReUpIconButton iconName={"times"} type={2}
              appManager={appManager}
              onPress={() => {
                if( thisThing._modalOpen )
                {
                  thisThing._webView.injectJavaScript("ReUpCloseAllModals()");
                  thisThing._modalOpen = false;
                }
                else
                {
                  thisThing.props.appActions.hideAlert();  
                  thisThing.props.appManager._loggedOutOrderingStoreIDSelected = null;
                  thisThing.updateActiveOrders(function(shouldUpdateAgain)
                  {
                    if( shouldUpdateAgain ) thisThing.queueToPollActiveOrders();
                  });                
                }
              }}
              />
          </View>
          <View style={{flex:1, alignItems:'center', justifyContent:'center', backgroundColor:'transparent', paddingHorizontal:10}}>
            <View style={{alignSelf:'center', alignItems:'center', justifyContent:'center'}}>
              <ReUpText appManager={appManager} style={[{
                fontSize:titleFontSize,
                fontWeight: '500',
                textAlign:'center'
              }, {color: appManager.getColorForKey("HeaderTitleColor")}]}>
              {
                title
              }
              </ReUpText>
            </View>
          </View>
          <View style={{width:50, height:Globals.ACTION_BAR_HEIGHT, alignItems:'center', justifyContent:'center'}}>
            <ReUpIconButton iconName={"refresh"} type={2}
              appManager={appManager}
              onPress={() => {
                if( typeof thisThing._webView !== 'undefined' )
                {
                  thisThing._webView.reload();
                  // thisThing._webView.injectJavaScript("jQuery.trigger('menu.reup');");
                }
              }}
              />
          </View>
        </View>
        <View style={{flex:1, width:this.state.layout.width, flexDirection:'column'}}>
          <WebView
            ref={(a)=>
            {
              thisThing._webView = a;
            }}
            onMessage={(event)=> 
            {
              if( typeof event === 'undefined' || event == null ) return;
              // probably ios
              if( typeof event.body !== 'undefined' && typeof event.body.data !== 'undefined' && typeof event.body.data.url !== 'undefined' )
              {
                thisThing.setLocationURL(event.body.data.url);
              }
              // probably android
              else if( typeof event.nativeEvent !== 'undefined' && typeof event.nativeEvent.data !== 'undefined')
              {
                try
                {
                  var data = JSON.parse(event.nativeEvent.data);
                  if( typeof data.url !== 'undefined' )
                  {
                    thisThing.setLocationURL(data.url);
                  }
                }
                catch(e){}
              }
            }}
            javaScriptEnabled={true}
            domStorageEnabled={true}
            scrollEventThrottle={20}
            injectedJavaScript={injectedJavaScript}
            startInLoadingState={false}
            decelerationRate="normal"
            startInLoadingState={true} onLoad={thisThing.webViewLoaded} source={{ uri: url }} style={{width:navLayout.width, flex:1}} renderLoading={function()
            {
              return <MKSpinner strokeColor={[appManager.getColorForKey("HeaderTitleColor"), appManager.getColorForKey("HeaderColor")]} style={{alignSelf:'center', marginTop:(thisThing.state.layout.height/2)}}/>
            }
          }/>
        </View>
      </View>
    </View>;

    this.props.appActions.setCustomAlertShown(true, alert, function(){}, true)
  },

  _locationURL:"",
  _modalOpen:false,
  _checkoutOpen:false,
  setLocationURL: function(newURL)
  {
    // console.log("new url: ", newURL)
    if( this._locationURL != newURL )
    {
      this._locationURL = newURL;
      
      // detect if a modal is open and have the "x" override to close the modal
      this._modalOpen = getParameterByName(newURL, "modalOpen") == "true";
      this._checkoutOpen = getParameterByName(newURL, "checkoutOpen") == "true";

      if( this._checkoutOpen )
      {
        this.doLogin();
      }
      else
      {
        // auphan has a url change that includes the file order_type_time.php, so check for that
        var isCheckingOut = this._locationURL.indexOf("order_type_time.php") >= 0;
        if( isCheckingOut ) this.doLogin();
      }
    }
  },

  doLogin: function()
  {
    if( this.props.appManager.isLoggedIn() ) return;

    var thisThing = this;
    var appActions = this.props.appActions;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var alertTitle = this.props.appManager.getLocalizationManager().localizedStringForKey("ORDER_AHEAD_LOGIN_ALERT_TITLE", "Requires Login");
    var alertBody = this.props.appManager.getLocalizationManager().localizedStringForKey("ORDER_AHEAD_LOGIN_ALERT_BODY", "Please log in or create your account to place your order.");
    var alertButton = this.props.appManager.getLocalizationManager().localizedStringForKey("LOGIN_BUTTON");
    appActions.hideAlert();
    appActions.showLocalizedAlert(alertTitle, alertBody, [alertButton], [function()
    {
      appActions.hideAlert();
      appActions.requestFeatureName('Login', {}, false, ()=>
      {
        appManager.setData({"OrderingLocations":[]}, ()=>
        {
          if( typeof appManager.getFeatureForName("Grabb") !== 'undefined' ) appActions.requestFeatureName('Grabb', {shouldSpinUntilUpdated:true}, false, ()=>{}, true)
          else if( typeof appManager.getFeatureForName("Auphan") !== 'undefined' ) appActions.requestFeatureName('Auphan', {shouldSpinUntilUpdated:true}, false, ()=>{}, true)
          else if( typeof appManager.getFeatureForName("OrderAhead") !== 'undefined' ) appActions.requestFeatureName('OrderAhead', {shouldSpinUntilUpdated:true}, false, ()=>{}, true)
        })
      }, true, false)
    }], function(){});
  },

  didSelectMap: function()
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var thisThing = this;
    var navLayout = this.props.appActions.navLayout;

    var alert = <View style={{flexDirection:'column', backgroundColor:appManager.getColorForKey("GeneralColor"), height:navLayout.height}} >
      {this.state.mapView}
      <View style={{position:'absolute', bottom:10, left:10, right:10}}>
        <ReUpButton appManager={appManager} onPress={()=>
        {
          thisThing.props.appActions.setCustomAlertShown(false);
        }}
        text={locManager.localizedStringForKey("CLOSE_MAP_BUTTON")} />
      </View>
    </View>;

    this.props.appActions.setCustomAlertShown(true, alert, function(){}, true)
  },

  didSelectLocationMap: function(location)
  {
    var {latitude, longitude} = getLocationInfo(location);
    // "https://www.google.com/maps/preview/@-15.623037,18.388672,8z"
    var url = "https://www.google.com/maps?q="+latitude+","+longitude
    var barTintColor = this.props.appManager.getColorForKey("HeaderColor");
    var tintColor = this.props.appManager.getColorForKey("HeaderIconColor");
    LinkingManager.openURL(url, tintColor, barTintColor);
  },

  webViewLoaded: function()
  {
    var thisThing = this;
    setTimeout(function()
    {
      Animated.timing(
       thisThing.state.webViewLoadingOpacity,
       {toValue: 0,
       duration:500},
      ).start(function()
      {
        thisThing.setState({isWebViewLoading: false});
      });
    },500)
  },

  showLocationInfo: function(location)
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var okButton = "Absorb";

    var {name, address} = getLocationInfo(location);
    var title = name;
    var body = address;

    var hoursDelivery = [];
    var hoursPickup = [];
    var shouldShowPickup = false;
    var shouldShowDelivery = false;
    if( typeof location.hours !== 'undefined' && location.hours.length > 0 )
    {
      var dayNames = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
      for( var i = 0; i < location.hours.length; i++ )
      {
        var hourDelivery = location.hours[i].delivery;
        if( typeof hourDelivery !== 'undefined' )
        {
          var openTimeParts = typeof hourDelivery[0] !== 'undefined' && hourDelivery[0].length > 0 ? hourDelivery[0][0].split(":") : [];
          var openTime = openTimeParts.length >= 2 ? (openTimeParts[0] + ":" + openTimeParts[1]) : "";
          var closedTimeParts = typeof hourDelivery[0] !== 'undefined' && hourDelivery[0].length > 1 ? hourDelivery[0][1].split(":") : [];
          var closedTime = closedTimeParts.length >= 2 ? (closedTimeParts[0] + ":" + closedTimeParts[1]) : "";
          var isActive = openTime != closedTime;
          if( isActive ) shouldShowDelivery = true;
          hoursDelivery.push({dayName:locManager.nameOfDay(i), timeFrom:locManager.localizedTime(openTime), timeTill:locManager.localizedTime(closedTime), isActive:isActive})
        }

        var hourPickup = location.hours[i].pickup;
        if( typeof hourPickup !== 'undefined' )
        {
          var openTimeParts = typeof hourPickup[0] !== 'undefined' && hourPickup[0].length > 0 ? hourPickup[0][0].split(":") : [];
          var openTime = openTimeParts.length >= 2 ? (openTimeParts[0] + ":" + openTimeParts[1]) : "";
          var closedTimeParts = typeof hourPickup[0] !== 'undefined' && hourPickup[0].length > 1 ? hourPickup[0][1].split(":") : [];
          var closedTime = closedTimeParts.length >= 2 ? (closedTimeParts[0] + ":" + closedTimeParts[1]) : "";
          var isActive = openTime != closedTime;
          if( isActive ) shouldShowPickup = true;
          hoursPickup.push({dayName:locManager.nameOfDay(i), timeFrom:locManager.localizedTime(openTime), timeTill:locManager.localizedTime(closedTime), isActive:isActive})
        }
      }
    }

    if( typeof location.Hours !== 'undefined' && location.Hours.length > 0 )
    {
      for( var i = 0; i < location.Hours.length; i++ )
      {
        var hour = location.Hours[i];
        var openTimeParts = typeof hour.OpenTime !== 'undefined' ? hour.OpenTime.split(":") : [];
        var openTime = openTimeParts.length >= 2 ? (openTimeParts[0] + ":" + openTimeParts[1]) : "";
        var closedTimeParts = typeof hour.ClosedTime !== 'undefined' ? hour.ClosedTime.split(":") : [];
        var closedTime = closedTimeParts.length >= 2 ? (closedTimeParts[0] + ":" + closedTimeParts[1]) : "";
        var isActive = hour.OpenTime != hour.ClosedTime;
        if( isActive ) shouldShowPickup = true;
        hoursPickup.push({dayName:hour.DayOfWeek, timeFrom:locManager.localizedTime(openTime), timeTill:locManager.localizedTime(closedTime), isActive})
      }
    }

    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);

    var closedLabel = "closed";

    var customAlert = <ScrollView bounces={true} style={{margin:0,padding:4,marginLeft:4,marginRight:4}}
      keyboardShouldPersistTaps={true}
      keyboardDismissMode={"interactive"}>
      <MKButton onPress={() => { thisThing.didSelectLocationMap(location) }} maskBorderRadius={0}
      rippleColor={primaryButtonColorLight}>
        <View style={{flexDirection:'column', marginVertical:4, flex:1}}>
          <View style={{flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
            <View style={{width:30}} />
            <View style={{flex:1}}>
              <ReUpText appManager={appManager} isTitle={true} style={{textAlign:'center'}}>
                {title}
              </ReUpText>
            </View>
            <View style={{width:30, alignSelf:'flex-start', flexDirection:'row'}}>
              <View style={{flex:1}} />
              <Icon name={"map"} size={13} color={generalTitleColor}/>
            </View>
          </View>
          <ReUpText appManager={appManager} style={{marginTop:10, textAlign:'left', textAlign:'center'}}>
            {body}
          </ReUpText>
        </View>
      </MKButton>
      <View>
      {
        shouldShowPickup ?
          <View style={{alignItems:'stretch'}}>
            <View style={{justifyContent:'center', alignSelf:'center', marginTop:4, marginBottom:8}}><ReUpText>{locManager.localizedStringForKey("FOR_PICK_UP_LABEL")}</ReUpText></View>
            {
              hoursPickup.map(function(hour, index)
              {
                var isClosed = !hour.isActive;
                var dayName = hour.dayName;
                var time = isClosed ? closedLabel : hour.timeFrom + " - " + hour.timeTill;
                return (
                  <View style={{paddingLeft:4,
                      paddingRight:4,
                      marginBottom:4,
                      flexDirection:'row'}}>
                    <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={
                      {
                        fontStyle:'italic',
                        flex:-1, color:generalTitleColor
                      }}>
                      {dayName}
                    </ReUpText>
                    <View style={{flex:1}}/>
                    <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={[{
                        fontStyle:'italic',
                        flex:-1,
                        textAlign:'right'
                      }, {color:generalTitleColor}]}>
                      {time}
                    </ReUpText>
                  </View>
                )
              })
            }
          </View>
        : null
      }
      {
        shouldShowDelivery > 0 ?
          <View style={{alignItems:'stretch'}}>
            <View style={{justifyContent:'center', alignSelf:'center', marginTop:4, marginBottom:8}}><ReUpText>{locManager.localizedStringForKey("FOR_DELIVERY_LABEL")}</ReUpText></View>
            {
              hoursDelivery.map(function(hour, index)
              {
                var isClosed = !hour.isActive;
                var dayName = hour.dayName;
                var time = isClosed ? closedLabel : hour.timeFrom + " - " + hour.timeTill;
                return (
                  <View style={{paddingLeft:4,
                      paddingRight:4,
                      marginBottom:4,
                      flexDirection:'row'}}>
                    <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={
                      {
                        fontStyle:'italic',
                        flex:-1, color:generalTitleColor
                      }}>
                      {dayName}
                    </ReUpText>
                    <View style={{flex:1}}/>
                    <ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={[{
                        fontStyle:'italic',
                        flex:-1,
                        textAlign:'right'
                      }, {color:generalTitleColor}]}>
                      {time}
                    </ReUpText>
                  </View>
                )
              })
            }
          </View>
        : null
      }
      </View>
    </ScrollView>;
    this.props.appActions.setCustomAlertShown(true, customAlert, function(){});
  },

  onRegionChange: function(region)
  {
    this.state.region = region;
  },

  locationForStoreID: function(storeID)
  {
    if( typeof storeID === 'undefined' && this.state.locations.length > 0 ) return this.state.locations[0];

    for( var i = 0; i < this.state.locations.length; i++ )
    {
      if( this.state.locations[i].store_id == storeID ) return this.state.locations[i];
    }

    return null;
  },

  render: function()
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();

    var featureName = "OrderAhead";
    var auphanFeatureData = appManager.getFeatureForName("Auphan");
    var grabbFeatureData = appManager.getFeatureForName("Grabb");
    if( typeof auphanFeatureData !== 'undefined' ) featureName = "Auphan";
    else if( typeof grabbFeatureData !== 'undefined' ) featureName = "Grabb";

    if( this.state.locations.length <= 0 )
    {
      return <View style={{paddingTop:Globals.ACTION_BAR_HEIGHT, backgroundColor:this.props.appManager.getColorForKey("GeneralColor"), flex:1, alignSelf:'stretch'}}><ReUpScrollView ref={(c) => { this._ref_ptr = c; }} shouldOverlayRefreshView={true} bounces={true} responder={this} isEmpty={true} customDependencies={[OrderAhead.customDataDependency]} featureName={featureName} isEmptyPostfix={locManager.localizedStringForKey("NO_LOCATIONS_AVAILABLE_STATEMENT")} /></View>
    }
    var locations = this.state.filteredLocations;
    var instructions = this.props.featureData.instructions;
    var thisThing = this;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();
    var user = appManager.currentUser();

    var instructionColor = appManager.getColorForKey("InstructionColor", 1);
    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var generalTitleColorLight = appManager.getColorForKey("GeneralTitleColor", 0.6);
    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
    var progressForegroundColor = appManager.getColorForKey("PrimaryColor");
    var progressBackgroundColor = appManager.getColorForKey("SecondaryColor");
    var noLocationsAvailableStr =  locManager.localizedStringForKey("NO_LOCATIONS_AVAILABLE_STATEMENT");
    if( progressBackgroundColor == generalColor ) progressBackgroundColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor", 0.4);

    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");

    if( this.state.activeOrders != null && this.state.activeOrders.length > 0 )
    {
      return (<View style={{backgroundColor:generalColor, height:1000}}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <View style={[styles.backgroundView, {width:this.state.layout.width, height:this.state.layout.height+Globals.ACTION_BAR_HEIGHT, overflow:'hidden', backgroundColor: generalColor}]} />
        <ReUpScrollView ref={(c) => { this._ref_ptr = c; }} shouldOverlayRefreshView={true} responder={this} isEmpty={false} customDependencies={[OrderAhead.customDataDependency]} featureName={featureName} isEmptyPostfix={noLocationsAvailableStr}>
        {
          this.state.activeOrders.map((order, index)=>
          {
            var location = thisThing.locationForStoreID(order.store_id);
            if( location == null ) return null;

            var {name, address, latitude, longitude, storeID} = getLocationInfo(location);
            var region = {
              latitude:parseFloat(latitude),
              longitude:parseFloat(longitude),
              latitudeDelta:0.003,longitudeDelta:0.003
            };
            var markers = [
              {
                latlng : {
                  latitude:parseFloat(latitude),
                  longitude:parseFloat(longitude)
                },
                title:name,
                description:address
              }
            ]
            var status = typeof order.status !== 'undefined' ? order.status : order.OrderStatus;
            var orderID = typeof order.order_id !== 'undefined' ? order.order_id : order.OrderId;
            return (
                <View key={storeID} style={{flexDirection:'column'}}>
                  <MKButton key={"map"}
                    backgroundColor={'transparent'}
                    shadowRadius={2}
                    shadowOffset={{width:0, height:2}}
                    shadowOpacity={0.7}
                    rippleColor={rippleColor}
                    shadowColor={'transparent'}
                    onPress={() => {
                      thisThing.didSelectLocationMap(location);
                    }} style={{height:150, flex:1}}>
                    <MapView key="mapviewactiveorder"
                      region={region}
                      onRegionChange={thisThing.onRegionChange}
                      style={{width:thisThing.state.layout.width, height:150}}
                    >
                      {markers.map(marker => (
                        <MapView.Marker
                          key="activeordermarkers"
                          coordinate={marker.latlng}
                          title={marker.title}
                          description={marker.description}
                        />
                      ))}
                    </MapView>
                  </MKButton>
                  <View key="active" style={{flexDirection:'row', alignItems:'center'}}>
                    <MKButton key={JSON.stringify(location)}
                      backgroundColor={'transparent'}
                      shadowRadius={2}
                      shadowOffset={{width:0, height:2}}
                      shadowOpacity={0.7}
                      rippleColor={rippleColor}
                      shadowColor={'transparent'}
                      onPress={() => {
                        thisThing.showLocationInfo(location);
                        // thisThing.didSelectLocation(location);
                      }} style={{height:100, flex:1}}>
                      <View style={{flex:1, alignSelf:'stretch'}}>
                        <View style={{flexDirection:'column', height:100, flex:1}}>
                          <View style={{flex:1}} />
                          <View style={{padding:10}}>
                            <View style={{flex:-1}}>
                              <ReUpText appManager={appManager} isTitle={true}>
                              {
                                name
                              }
                              </ReUpText>
                            </View>
                            <View style={{height:10}} />
                            <View style={{flex:-1}}>
                              <ReUpText appManager={appManager}>
                              {
                                address
                              }
                              </ReUpText>
                            </View>
                            {
                              typeof location.distance !== 'undefined' && location.distance > 0 && location.distance < Number.MAX_VALUE ?
                                <ReUpText appManager={appManager} style={{color:generalTitleColorLight}}>
                                {
                                  locManager.localizedDistance(location.distance)
                                }
                                </ReUpText>
                              : null
                            }
                          </View>
                          <View style={{flex:1}} />
                        </View>
                      </View>
                    </MKButton>
                    <View style={{width:50, flex:-1}}>
                      <ReUpIconButton iconName={"info"} type={6}
                        appManager={appManager}
                        onPress={() => {
                          thisThing.showLocationInfo(location);
                        }}
                        />
                    </View>
                  </View>
                  {
                    typeof order.ready_time_seconds !== 'undefined' ?
                      <View style={{width:thisThing.state.layout.width, flex:-1, flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
                        <ReUpText appManager={appManager} isTitle={false} style={{textAlign:'left', marginHorizontal:20}}>
                          {this.state.orderIsReady ? locManager.localizedStringForKey("YOUR_ORDER_IS_READY_STATEMENT") : locManager.localizedStringForKey("YOUR_ORDER_WILL_BE_READY_STATEMENT")}
                        </ReUpText>
                        <ReUpCountdown ref={(countdown)=>
                          {
                            if( countdown != null )
                            {
                              thisThing._countdown = countdown;
                              appManager.getVariable(ACTIVE_ORDER_DISMISS_KEY, function(shouldIgnoreBelowReadyThisReadyTimeSeconds)
                              {
                                if( parseInt(shouldIgnoreBelowReadyThisReadyTimeSeconds) < parseInt(order.ready_time_seconds)  && typeof order.ready_time_seconds !== 'undefined' )
                                {
                                  countdown.startCountdown(moment(order.ready_time_seconds*1000).toDate());
                                }
                              })
                              // countdown.startCountdown(moment().add("second",2).add("minute",1).toDate());
                            }
                          }} appManager={appManager} isTitle={true} style={{textAlign:'center', marginHorizontal:20, fontSize:40}}
                          complete={()=>
                          {
                            appActions.showLocalizedAlert("ORDER_READY_ALERT_TITLE", "ORDER_READY_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
                            {
                              appManager.setVariable(ACTIVE_ORDER_DISMISS_KEY,  order.ready_time_seconds);
                              appActions.hideAlert();
                              thisThing.setState({activeOrders:null, orderIsReady:true})
                            }], function(){})
                          }}
                          completionText={locManager.localizedStringForKey("DONE_STATEMENT")}/>
                      </View>
                    :
                      <View style={{width:thisThing.state.layout.width, flex:-1, flexDirection:'column', justifyContent:'center'}}>
                        <ReUpText appManager={appManager} isTitle={true} style={{textAlign:'left', marginHorizontal:20}}>
                          {locManager.localizedStringForKeyAndParams("ORDER_STATUS_ORDER_NUMBER", [orderID], "Order #%0%")}
                        </ReUpText>
                        <View>
                          <View style={{flexDirection:'row', alignItems:'center', padding:20}}>
                            <View style={{height:20, width:20, borderRadius:10, borderColor:progressForegroundColor, borderWidth:2, alignItems:'center', justifyContent:'center'}}>
                              <View style={{height:10, width:10, borderRadius:5, backgroundColor:status < 0 ? 'transparent' : progressForegroundColor}} />
                            </View>
                            <View style={{flex:1, marginLeft:10}}>
                              <ReUpText appManager={appManager} style={{flexWrap:'wrap', textAlign:'left'}}>
                                {locManager.localizedStringForKey("ORDER_STATUS_SUBMITTED_RESTAURANT", "Order submitted to the restaurant")}
                              </ReUpText>
                            </View>
                          </View>
                          <ShadowView appManager={appManager} layout={thisThing.state.layout} />
                        </View>
                        <View style={{opacity:status <= 1 ? 0.4 : 1}}>
                          <View style={{flexDirection:'row', alignItems:'center', padding:20}}>
                            <View style={{height:20, width:20, borderRadius:10, borderColor:status <= 1 ? progressBackgroundColor : progressForegroundColor, borderWidth:2, alignItems:'center', justifyContent:'center'}}>
                              <View style={{height:10, width:10, borderRadius:5, backgroundColor:status <= 1 ? 'transparent' : progressForegroundColor}} />
                            </View>
                            <View style={{flex:1, marginLeft:10}}>
                              <ReUpText appManager={appManager} style={{flexWrap:'wrap', textAlign:'left'}}>
                                {locManager.localizedStringForKey("ORDER_STATUS_MEAL_BEING_PREPPED", "Your meal is being prepared!")}
                              </ReUpText>
                            </View>
                          </View>
                          <ShadowView appManager={appManager} layout={thisThing.state.layout} />
                        </View>
                        <View style={{opacity:status <= 2 ? 0.4 : 1}}>
                          <View style={{flexDirection:'row', alignItems:'center', padding:20}}>
                            <View style={{height:20, width:20, borderRadius:10, borderColor:status <= 2 ? progressBackgroundColor : progressForegroundColor, borderWidth:2, alignItems:'center', justifyContent:'center'}}>
                              <View style={{height:10, width:10, borderRadius:5, backgroundColor:status <= 2 ? 'transparent' : progressForegroundColor}} />
                            </View>
                            <View style={{flex:1, marginLeft:10}}>
                              <ReUpText appManager={appManager} style={{flexWrap:'wrap', textAlign:'left'}}>
                                {locManager.localizedStringForKey("ORDER_STATUS_READY_FOR_PICKUP", "Ready for pickup. Enjoy!")}
                              </ReUpText>
                            </View>
                          </View>
                        </View>
                      </View>
                  }
                  {
                    typeof order.ready_time_seconds !== 'undefined' ?
                      <View style={{padding:20}}>
                        <ReUpButton appManager={appManager} isSecondary={true} text={locManager.localizedStringForKey("HIDE_ORDER_BUTTON")} onPress={()=>
                        {
                          appManager.setVariable(ACTIVE_ORDER_DISMISS_KEY, order.ready_time_seconds);
                          thisThing.setState({activeOrders:null})
                        }}/>
                      </View>
                    : null
                  }
                </View>
              )
            })
          }
        </ReUpScrollView>
      </View>)
    }

    var shouldShowSearch = this.state.locations.length > 3;
    var showOtherLocationsWhenOneIsActive = false;
    var activeLocations = this.state.activeLocations;
    var shouldShowInstruction = false;
    var allMarkers = []
    var region = null;
    for( var i = 0; i < locations.length; i++ )
    {
      var {latitude, longitude, name, address} = getLocationInfo(locations[i]);
      if( region == null )
      {
        region = {
          latitude:latitude,
          longitude:longitude,
          latitudeDelta:0.01,
          longitudeDelta:0.01
        };
      }
      allMarkers.push({
          latlng : {
            latitude:parseFloat(latitude),
            longitude:parseFloat(longitude)
          },
          title:name,
          description:address
        })
      // TODO: ... Think about this..
      if( i >= 10 ) break;
    }

    var parallaxHeaderHeight = this.state.parallaxHeaderHeight;

    const AnimatedCustomScrollView = Animated.createAnimatedComponent(ReUpScrollView)

    return(
      <View style={[styles.container, {backgroundColor:generalColor}]}>
        { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
        <ParallaxScrollView
          ref={(c) => { this._ref_parallax = c; }}
          stickyHeaderHeight={thisThing.state.showOneLocation ? 0 : 45}
          backgroundColor={generalColor}
          contentBackgroundColor={generalColor}
          parallaxHeaderHeight={parallaxHeaderHeight}
          backgroundSpeed={1}
          onScroll={(info)=>
            {
              var offset = info.nativeEvent.contentOffset.y;
              if( offset < 50 ) Keyboard.dismiss();
            }}
          renderStickyHeader={()=>
          {
            if( thisThing.state.showOneLocation ) return null;
            return  (<View style={{flexDirection:'column', backgroundColor:generalColor, width:thisThing.state.layout.width, height:45}}>
              <View style={{flexDirection:'row', flex:1, alignItems:'center', justifyContent:'center', backgroundColor:generalColor}}>
                <View style={{width:30, marginHorizontal:10, alignItems:'center', flex:-1, justifyContent:'center'}}>
                  <Icon pointerEvents="auto" style={{}} name={"search"} size={16} color={generalTitleColorLight} />
                </View>
                <View style={{alignSelf:'stretch', flexDirection:'row', margin:0, flex:1}}>

                </View>
                <ReUpField
                  appManager={appManager}
                  ref={(a) => { thisThing._searchField = a }}
                  onChangeText={thisThing.searchChanged}
                  key={"search" + thisThing.state.searchKey}
                  hideLine={true}
                  onFocus={()=>
                  {
                    if( thisThing._ref_parallax ) thisThing._ref_parallax.scrollTo(parallaxHeaderHeight);
                  }}
                  disableBackground={true}
                  placeholder={locManager.localizedStringForKey("SEARCH_PLACEHOLDER")}
                  style={{
                    flex:1, height:50, position:'absolute', left:50, right:50, top:-4, bottom:0
                  }}
                  floatingLabelEnabled={false}/>
                <MKButton key={"info"}
                  backgroundColor={'transparent'}
                  shadowRadius={2}
                  shadowOffset={{width:0, height:2}}
                  shadowOpacity={0.7}
                  rippleColor={rippleColor}
                  shadowColor={'transparent'}
                  onPress={() => {
                    Keyboard.dismiss();
                    thisThing.searchChanged("");
                    thisThing.setState({searchKey:thisThing.state.searchKey+1});
                  }} style={{width:50}}>
                  <View style={{alignSelf:'stretch', flex:1, flexDirection:'column'}}>
                    <View style={{flex:1}} />
                    <View style={{flex:-1}}>
                      <ReUpIconButton iconName={"times"} type={6}
                        appManager={appManager}
                        onPress={() => {
                          Keyboard.dismiss();
                          thisThing.searchChanged("");
                          thisThing.setState({searchKey:thisThing.state.searchKey+1});
                        }}
                        />
                    </View>
                    <View style={{flex:1}} />
                  </View>
                </MKButton>
              </View>
              <ShadowView appManager={appManager} layout={thisThing.state.layout} />
            </View>)
          }}
          renderBackground={() => (<View key="mapviewcontainer" style={{ height: parallaxHeaderHeight, alignItems: 'center', flexDirection:'column', justifyContent: 'center' }}>
              {thisThing.state.mapView}
            </View>)}
          renderForeground={() => (<View style={{flexDirection:'column', backgroundColor:'transparent'}}>
          {
            shouldShowInstruction ?
              <View style={[styles.instructionContainer, {flexDirection:'column', backgroundColor:instructionColor, color:instructionTitleColor, width:this.state.layout.width}]}
                onLayout={(evt)=>{thisThing.setState({instructionHeight:evt.nativeEvent.layout.height})}}>
                <View style={{flexDirection:'row', flex:-1, alignSelf:'stretch', alignItems:'stretch'}}>
                  <View style={{alignSelf:'center'}}>
                    <ReUpText appManager={appManager} style={[styles.instructionText, {color:instructionTitleColor}]}>
                      {creditsLeftStatement}
                    </ReUpText>
                  </View>
                  <View style={{flex:1}} />
                  <View pointerEvents={"auto"} style={{flex:-1}}>
                    <ReUpIconButton type={3}
                      appManager={appManager}
                      featureData={this.props.featureData}
                      appActions={this.props.appActions}
                      />
                  </View>
                </View>
                <ShadowView appManager={appManager} layout={this.state.layout} />
              </View>
            : null
          }
            <MKButton
              backgroundColor={'transparent'}
              shadowRadius={0}
              shadowOffset={{width:0, height:0}}
              shadowOpacity={0}
              shadowColor={'transparent'}
              rippleColor={appManager.getColorForKey("ButtonPrimaryColor", .2)}
              maskBorderRadius={0}
              style={{width:thisThing.state.layout.width, height:parallaxHeaderHeight - (shouldShowInstruction ? thisThing.state.instructionHeight : 0)}}
              onPress={()=>
              {
                thisThing.didSelectMap();
              }}/>
            </View>
            )}>
            <View style={{flexDirection:'row', width:this.state.layout.width}}>
              <View style={{height:this.props.initialLayout.height - (shouldShowInstruction ? this.state.instructionHeight : 0) - 60 - (thisThing.state.showOneLocation ? 60 : 0), width:0}} />
              <View style={{flexDirection:'column'}}>
                {
                  true || !thisThing.state.showOneLocation ?
                    <View style={{flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
                      <ShadowView appManager={appManager} layout={thisThing.state.layout} />
                      <View style={{padding:10, textAlign:'center', justifyContent:'center', alignItems:'center'}}>
                        <ReUpText type={1} appManager={appManager}>
                          {this.props.featureData.instructions + ""}
                        </ReUpText>
                      </View>
                      {!thisThing.state.showOneLocation ? <ShadowView appManager={appManager} layout={thisThing.state.layout} /> : null}
                    </View>
                  : null
                }
                {
                  locations.length <= 0 ?
                    <View key="empty" style={{backgroundColor:generalColor, height:-1, flexDirection:'column', alignItems:'center', justifyContent:'center', marginTop:20}}>
                      <Icon name={thisThing.props.featureData.icon.replace("fa-", "")} size={62} color={generalTitleColor}/>
                      <View style={{flexDirection:'column', justifyContent:'center', alignItems:'center', padding:20}}>
                        <ReUpText appManager={appManager} isTitle={true}>{thisThing.props.featureData.title}</ReUpText>
                        <ReUpText appManager={appManager} style={{textAlign:'center'}}>{locManager.localizedStringForKey("NO_LOCATIONS_STATEMENT", "No locations for this search.")}</ReUpText>
                      </View>
                    </View>
                  : null
                }
              {
                locations.map(function(location, index)
                {
                  if( thisThing.state.showOneLocation && index > 0 ) return null;
                  if( index > 20 ) return null;

                  var {latitude, longitude, name, address, storeID} = getLocationInfo(location);
                  var cannotOrder = false;//location.IsClosedForTheDay || !location.IsRestaurantOpen;
                  return (
                    <View key={storeID} style={{flexDirection:'column', width:thisThing.state.layout.width, alignItems:'stretch'}}>
                    {
                      thisThing.state.showOneLocation ?
                        <ShadowView appManager={appManager} layout={thisThing.state.layout} />
                      : null
                    }
                      <View style={{alignItems:'center', flexDirection:'row'}}>
                        <MKButton key={JSON.stringify(location)}
                          backgroundColor={'transparent'}
                          shadowRadius={2}
                          shadowOffset={{width:0, height:2}}
                          shadowOpacity={0.7}
                          rippleColor={rippleColor}
                          shadowColor={'transparent'}
                          onPress={() => {
                            if( cannotOrder )
                            {
                                appActions.showLocalizedAlert("LOCATION_CLOSED_ALERT_TITLE", "LOCATION_CLOSED_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
                                {
                                appActions.hideAlert();
                              }], function(){})
                            }
                            else
                            {
                              thisThing.didSelectLocation(location);
                            }
                          }} style={{height:100, flex:1, opacity: thisThing.state.activeLocation != null ? 0.4 : 1}} enabled={thisThing.state.activeLocation == null}>
                          <View style={{flexDirection:'column', height:100, flex:1}}>
                            <View style={{flex:1}} />
                            <View style={{padding:10}}>
                              <ReUpText appManager={appManager} isTitle={true}>
                              {
                                name + (cannotOrder ? " (Closed)" : "")
                              }
                              </ReUpText>
                              <View style={{height:10}} />
                              <ReUpText appManager={appManager}>
                              {
                                address
                              }
                              </ReUpText>
                              {
                                typeof location.distance !== 'undefined' && location.distance > 0 && location.distance < Number.MAX_VALUE ?
                                  <ReUpText appManager={appManager} style={{color:generalTitleColorLight}}>
                                  {
                                    locManager.localizedDistance(location.distance)
                                  }
                                  </ReUpText>
                                : null
                              }
                            </View>
                            <View style={{flex:1}} />

                          </View>
                        </MKButton>
                        <MKButton key={"info"}
                          backgroundColor={'transparent'}
                          shadowRadius={2}
                          shadowOffset={{width:0, height:2}}
                          shadowOpacity={0.7}
                          rippleColor={rippleColor}
                          shadowColor={'transparent'}
                          onPress={() => {
                            thisThing.showLocationInfo(location);
                          }} style={{height:100, width:50, opacity: thisThing.state.activeLocation != null ? 0.4 : 1}} enabled={thisThing.state.activeLocation == null}>
                          <View style={{alignSelf:'stretch', flex:1, flexDirection:'column'}}>
                            <View style={{flex:1}} />
                            <View style={{flex:-1}}>
                              <ReUpIconButton iconName={"info"} type={6}
                                appManager={appManager}
                                onPress={() => {
                                  thisThing.showLocationInfo(location);
                                }}
                                />
                            </View>
                            <View style={{flex:1}} />
                          </View>
                        </MKButton>
                      </View>
                      <ShadowView appManager={appManager} layout={thisThing.state.layout} />
                      {
                        thisThing.state.showOneLocation ?
                          <View>
                            <ReUpButton appManager={appManager} onPress={()=>
                            {
                              if( cannotOrder )
                              {
                                appActions.showLocalizedAlert("LOCATION_CLOSED_ALERT_TITLE", "LOCATION_CLOSED_ALERT_BODY", ["OK_ALERT_BUTTON"], [function()
                                {
                                  appActions.hideAlert();
                                }], function(){})
                              }
                              else
                              {
                                thisThing.didSelectLocation(location);
                              }
                            }}
                            text={locManager.localizedStringForKey("ORDER_NOW_BUTTON")} style={{margin:10}}/>
                            {
                              thisThing.state.locations.length > 1 ?
                                <ReUpButton isSecondary={true} appManager={appManager} onPress={()=>
                                {
                                  thisThing.setState({showOneLocation:false});
                                }}
                                text={locManager.localizedStringForKey("SEE_MORE_LOCATIONS_BUTTON")} style={{marginHorizontal:10}} />
                              : null
                            }
                          </View>
                        : null
                      }
                    </View>
                    )
                })
              }
              </View>
            </View>
        </ParallaxScrollView>
      </View>
    )
    // return (<View style={styles.container}>
    //   { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
    //   {
    //     url == null ?
    //     null
    //     :
    //     <WebView  url={url} style={{flex:1}} />
    //   }
    // </View>)
  }
});

OrderAhead.getCards = function(featureData, appActions, data)
{
  var appManager = appActions._appManager;

  var auphanFeatureData = appManager.getFeatureForName("Auphan");
  var grabbFeatureData = appManager.getFeatureForName("Grabb");

  var featureName = "OrderAhead";
  if( typeof auphanFeatureData !== 'undefined' ) featureName = "Auphan";
  else if( typeof grabbFeatureData !== 'undefined' ) featureName = "Grabb";
  var didSelect = function() {appActions.requestFeatureName(featureName)};
  var iconName = featureData.data.icon.replace("fa-", "")
  var sortOrder = 999999999999;
  if( typeof data.OrderingLocations !== 'undefined' && data.OrderingLocations.length > 0 )
  {
    try {
      var locations = data.OrderingLocations;
      for( var i = 0; i < locations.length; i++ )
      {
        var location = locations[i];
        var cannotOrder = (typeof location.IsClosedForTheDay !== 'undefined' || typeof location.IsRestaurantOpen !== 'undefined') && (location.IsClosedForTheDay || !location.IsRestaurantOpen);
        if( !cannotOrder )
        {
          sortOrder = 0;
          break;
        }
      }
    } catch (e) {

    } finally {

    }

  }

  return [{
    didSelect : didSelect,
    title : featureData.data.title,
    body1 : featureData.data.tip,
    icon : iconName,
    cardType : 0,
    sortOrder : sortOrder,
  }];
}

// OrderAhead.customDependencyKeys = ["OrderAhead"];
// OrderAhead.customDataDependency = function(appManager, completion)
// {
//   var auphanFeatureData = appManager.getFeatureForName("Auphan");
//   var grabbFeatureData = appManager.getFeatureForName("Grabb");

//   var updateFunction = null;
//   if( typeof auphanFeatureData !== 'undefined' )
//   {
//     updateFunction = function()
//     {
//       appManager.setUpdatedDateOfFeatureName("OrderAhead");

//       var date = (new Date()).getTime();
//       var currentDateTime =  appManager.getLocalizationManager().dateTimeAuphan(date);
//       // TODO: remove this
//       // auphanFeatureData.data.franchise_id = 6941;
//       NetworkManager.getAuphanInfo(appManager, "AUPHAN", auphanFeatureData.data.franchise_id, currentDateTime, "", "", function(data)
//       {
//         if( data != null && typeof data !== 'undefined' )
//         {
//           var currentPosition = appManager.getCurrentPosition();
//           var locations = data;
//           for( var i = 0; i < locations.length; i++ )
//           {
//             var loc = locations[i];
//             loc.distance = calculateDistance(loc.latitude, loc.longitude, currentPosition.latitude, currentPosition.longitude);
//           }
//           data = locations.sort(function(a,b)
//           {
//             if( a.distance == b.distance ) return a.name.localeCompare(b.name);

//             return a.distance - b.distance;
//           });

//           var output = {OrderAhead:[{Locations:JSON.stringify(data), store_id:0}]};
//           appManager.setData(output, function()
//           {
//             completion(output)
//           });
//         }
//         else
//         {
//           completion({})
//         }
//       }, function(a)
//       {
//         completion({OrderAhead:[]})
//       }, function()
//       {
//         completion({})
//       })
//     }
//   }
//   else if( typeof grabbFeatureData !== 'undefined' )
//   {
//     updateFunction = function()
//     {
//       appManager.setUpdatedDateOfFeatureName("OrderAhead");

//       var date = (new Date()).getTime();
//       var currentDateTime =  appManager.getLocalizationManager().dateTimeGrabb(date);
//       NetworkManager.getGrabbInfo(appManager, grabbFeatureData.data.merchantID, currentDateTime, function(data)
//       {
//         if( data != null && typeof data.Locations !== 'undefined' && data.Locations != null )
//         {
//           appManager._grabbToken = data.Token;

//           var currentPosition = appManager.getCurrentPosition();
//           var locations = data.Locations;
//           var refinedLocations = [];
//           for( var i = 0; i < locations.length; i++ )
//           {
//             var loc = locations[i];
//             var refinedLoc = {};
//             refinedLoc.distance = calculateDistance(loc.latitude, loc.longitude, currentPosition.latitude, currentPosition.longitude);
//             refinedLoc.address = loc.Address.Line1 + " " + loc.Address.Line2;
//             refinedLoc.name = loc.Name;
//             refinedLoc.store_id = loc.LocationID;
//             refinedLoc.url = loc.GrabbURL;
//             refinedLoc.latitude = loc.Address.Latitude;
//             refinedLoc.longitude = loc.Address.Longitude;
//             refinedLoc.hours = [];
//             for( var j = 0; j < loc.Hours.length; j++ )
//             {
//               refinedLoc.hours.push({
//                 pickup:[
//                   [loc.Hours[j].OpenTime, loc.Hours[j].ClosedTime]
//                 ],
//                 delivery:[],
//               })
//             }
//             refinedLoc.active_orders = [];
//             if( typeof loc.ActiveOrders !== 'undefined' )
//             {
//               for( var j = 0; j < loc.ActiveOrders.length; j++ )
//               {
//                 refinedLoc.active_orders.push({
//                   status:loc.ActiveOrders[j].OrderStatus,
//                   store_id:loc.LocationID,
//                   order_id:loc.ActiveOrders[j].OrderId
//                 })
//               }
//             }

//             refinedLocations.push(refinedLoc);
//           }
//           refinedLocations = refinedLocations.sort(function(a,b)
//           {
//             if( a.distance == b.distance ) return a.name.localeCompare(b.name);

//             return a.distance - b.distance;
//           });

//           var output = {OrderAhead:[{Locations:JSON.stringify(refinedLocations), store_id:0}]};
//           appManager.setData(output, function()
//           {
//             completion(output)
//           });
//         }
//         else
//         {
//           completion({})
//         }
//       }, function(a)
//       {
//         completion({OrderAhead:[]})
//       }, function()
//       {
//         completion({})
//       })
//     }
//   }

//   var timeSinceLastUpdated = appManager.getTimeSinceLastUpdateOfFeatureName("OrderAhead");
//   if( timeSinceLastUpdated < 5000 )
//   {
//     appManager.getDataType("OrderAhead", function(data)
//     {
//       if( data != null && typeof data !== 'undefined' && data.length > 0 )
//       {
//         var locations = JSON.parse(data[0].Locations).sort(function(a,b)
//         {
//           if( a.distance == b.distance ) return a.name.localeCompare(b.name);

//           return a.distance - b.distance;
//         });
//         completion({OrderAhead:[{Locations:JSON.stringify(locations), store_id:0}]});
//       }
//       else
//       {
//         if( updateFunction != null ) updateFunction();
//       }
//     })
//   }
//   else
//   {
//     if( updateFunction != null ) updateFunction();
//   }

// }

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
    backgroundColor:'red'
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },
})
OrderAhead.dataDependencies = ["Users", "OrderingLocations"];

module.exports = OrderAhead;
